import React, { useState } from "react";
import ForgotPasswordForm from "../../components/forgotPasswordForm/ForgotPasswordForm";
import axiosClient from "../../api/axiosClient";
import Success from "../../components/success/Success";
import LoadingOverlay from "../../components/loadingOverlay/LoadingOverlay";

const ForgotPassword = () => {
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (email) => {
    setIsLoading(true);
    await axiosClient.post('auth/forgot-password', {
      email
    })
    .then((data) => {
      setSuccessMessage(data.message);
    })
    .catch((error) => {
      setError(error.message);
    })
    .finally(() => {
      setIsLoading(false);
    });
  };

  if(successMessage) {
    return (
      <Success
        message={successMessage}
        showLogin={false}
      />
    );
  }

  return (
    <>
      {isLoading && <LoadingOverlay />}
      <ForgotPasswordForm
        onSubmit={handleSubmit}
        error={error}
      />
    </>
  );
};

export default ForgotPassword;
